/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useState, useEffect } from 'react';
import Metrics from '@spotahome/soyuz-metrics';
import { trans, getResourcePath } from '@spotahome/soyuz/client';
import { ModalFullscreenClose } from '@spotahome/ui-library';
import Cookies from 'universal-cookie';

import BulletPoints from './BulletPoints';

import './ValuePropositionModal.scss';

const expireNineMonthsFromNow = () => {
  const timestamp = new Date().getTime();
  const expiration = timestamp + 1000 * 60 * 60 * 24 * 30 * 9;
  return new Date(expiration);
};

const MODAL_STEPS = {
  1: {
    header: '100% Online',
    title: 'search.value-proposition.step1-title',
    image: '/images/value-proposition/step1.jpg',
    mobileImage: '/images/value-proposition/step1-mobile.jpg'
  },
  2: {
    header: 'search.value-proposition.step2-header',
    title: 'search.value-proposition.step2-title',
    image: '/images/value-proposition/step2.jpg',
    mobileImage: '/images/value-proposition/step2-mobile.jpg'
  },
  3: {
    header: 'search.value-proposition.step3-header',
    title: 'search.value-proposition.step3-title',
    image: '/images/value-proposition/step3.jpg',
    mobileImage: '/images/value-proposition/step3-mobile.jpg'
  }
};

const ValuePropositionModal = () => {
  const [stepNumber, setStepNumber] = useState(1);
  const [isModalOpen, setModalIsOpen] = useState(true);
  const cookies = new Cookies();

  useEffect(
    () =>
      cookies.set('seen-value-proposition-modal', true, {
        path: '/',
        expires: expireNineMonthsFromNow()
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const MODAL_STEPS_LENGTH = Object.keys(MODAL_STEPS).length;

  const decreaseStep = () => stepNumber > 1 && setStepNumber(stepNumber - 1);

  const increaseStep = () => {
    if (stepNumber < MODAL_STEPS_LENGTH) {
      setStepNumber(stepNumber + 1);
      Metrics.ga.sendEvent(
        'Search',
        'value-proposition-modal_next-step',
        stepNumber
      );
    }
  };

  const goToStep = desiredStep =>
    stepNumber !== desiredStep && setStepNumber(desiredStep);

  const handleModalClose = () => {
    Metrics.ga.sendEvent('Search', 'value-proposition-modal_close', 'close');
    setModalIsOpen(false);
  };

  return (
    <ModalFullscreenClose
      size="big"
      className="value-proposition-modal"
      isOpen={isModalOpen}
      onRequestClose={handleModalClose}
    >
      <div className="value-proposition-modal__images">
        <picture>
          <source
            media="(max-width: 480px)"
            srcSet={getResourcePath(MODAL_STEPS[stepNumber].mobileImage)}
          />
          <img
            alt={MODAL_STEPS[stepNumber].header}
            src={getResourcePath(MODAL_STEPS[stepNumber].image)}
          />
        </picture>
      </div>

      <div
        className="value-proposition-modal__content"
        data-test="valuePropositionModal"
      >
        <span className="value-proposition-modal__content-header">
          {trans(MODAL_STEPS[stepNumber].header)}
        </span>
        <h1 className="value-proposition-modal__content-title">
          {trans(MODAL_STEPS[stepNumber].title)}
        </h1>
      </div>

      <div className="value-proposition-modal__footer">
        <p
          className="value-proposition-modal__cta value-proposition-modal__cta--prev"
          onClick={decreaseStep}
        >
          {stepNumber > 1 ? trans('search.value-proposition.previous') : ''}
        </p>
        <div className="value-proposition-modal__bullets-container">
          <BulletPoints
            totalSteps={MODAL_STEPS_LENGTH}
            currentStep={stepNumber}
            handleOnClick={goToStep}
          />
        </div>
        <p
          className="value-proposition-modal__cta value-proposition-modal__cta--next"
          onClick={increaseStep}
        >
          {stepNumber < MODAL_STEPS_LENGTH
            ? trans('search.value-proposition.next')
            : ''}
        </p>
      </div>
    </ModalFullscreenClose>
  );
};

export default ValuePropositionModal;
